import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        num: 7,
        email: 'abc@qq.com'
    },
    mutations: {
        numAddOne(state){
            //num自增1
            state.num++;
        }
    },
    actions: {
        numAddOneAsync(context) {//{commit, state}
            setTimeout(() => {
                context.commit('numAddOne') 
            }, 1000) 
        }
    },
    getters:{
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js